module.exports = __webpack_public_path__ + "b3a3605a8cf9a1e14b2cbf8c39c5a813.jpg";